module.exports = __webpack_public_path__ + "static/media/sailec.abcdb782.woff";